import { render, staticRenderFns } from "./NewCustomerNote.vue?vue&type=template&id=2a5c5dc7&"
import script from "./NewCustomerNote.vue?vue&type=script&lang=js&"
export * from "./NewCustomerNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports